<template>
	<div class="flex h-full w-full items-center justify-center">
		<router-view></router-view>
	</div>
</template>

<script lang="js" src="./App.js"></script>
